function initContactUs() {
  const contactLinks = document.querySelector('[data-contact-us]');
  if (contactLinks) {
    contactLinks.setAttribute('href', 'javascript:void(0)');
    contactLinks.addEventListener('click', function (event) {
      event.preventDefault();
      const launcher = document.getElementById('launcher');
      if (launcher && launcher.contentWindow) {
        const embedElement = launcher.contentWindow.document.getElementById('Embed');
        if (embedElement) {
          const button = embedElement.getElementsByTagName('button')[0];
          if (button) {
            button.click();
          }
        }
      }
    });
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', initContactUs);